import { urls } from 'Src/constants/Urls'
import { RequestParams } from 'Models'
import { TYPE_REPORT } from 'Src/constants/TypeReport'
import { SimpleResponse } from 'Types/simpleResponse'
import { axiosDS } from '@pp/axios'

export const reportApi = {
	getReport: async (typeReport: string, params: RequestParams) => {
		const url = urls.modules.reports[typeReport]
		const res = await axiosDS().get(url, { params })
		return res.data
	},
	getReportWithConfig: async (typeReport: string, params: RequestParams, columns: string[]) => {
		const url = urls.modules.reports[typeReport]
		const res = await axiosDS().post(url, { ...params, columns })
		return res.data
	},
	setReport: async (file: Blob) => {
		const data = new FormData()
		data.append('data[file]', file)
		const res = await axiosDS().post<SimpleResponse>(
			urls.modules.reports[TYPE_REPORT.BULK_CREATION],
			data
		)
		return res.data
	},
}
